import * as actionTypes from './actionTypes';

export const login = authToken => ({
    type: actionTypes.AUTH_LOGIN,
    payload: {authToken}
})

export const twoFactorUuidRequested = twoFactorUuid => ({
    type: actionTypes.TWO_FACTOR_UUID_REQUESTED,
    payload: {twoFactorUuid}
})

export const cancelTwoFactorValidation = () => {
    return {type: actionTypes.CANCEL_TWO_FACTOR_VALIDATION};
}

export const resetPassword = () => {
    return {type: actionTypes.AUTH_RESET_PASSWORD};
}

export const fulfillUser = (user, avatar) => ({
    type: actionTypes.USER_LOADED,
    payload: {user, avatar}
})

export const logout = () => ({type: actionTypes.AUTH_LOGOUT})
